import React, { useEffect, useState } from 'react';

import Search from '../Search';

import './style.scoped.scss';
import Breadcrumbs from '../Breadcrumbs';
import BackButton from '../Buttons/BackButton';
import { connect } from 'react-redux';
import { findFirstPageWithContent } from '../../store/Document/documentActions';
import Bookmark from './Bookmark';

const HeaderBar = ({
  currentPage,
  currentDocument,
  pageTitle,
  backGoesHome,
  handleSearch,
  handleLevelSelected,
  filter,
  contentType,
}) => {
  const [contentSummary, setContentSummary] = useState(false);

  const search = (input, isAdvanced) => {
    isAdvanced ? handleSearch(input, isAdvanced) : handleSearch(input);
  };

  // to remove the terminology "Cover" from appearing as a title
  const hideCoverTitle =
    currentPage &&
    currentPage.title.match(/Cover/i) &&
    findFirstPageWithContent(currentDocument.pages).id === currentPage.id;

    useEffect(() => {
      if (contentType === 'Summary') setContentSummary(true);
      else setContentSummary(false);
    }, [contentType]);

  if (pageTitle) {
    return (
      <div className="headerBar account-page">
        <div className="back-button-wrapper">
          <BackButton isAccount backGoesHome={backGoesHome} filter={filter} />
        </div>
        <h2 className='m-0 p-0'>{pageTitle}</h2>
      </div>
    );
  }

  return (
    <div className="headerBar">
      {/* desktop view */}
      <div id="desktop-view">
        <div className="d-flex justify-content-start align-items-center">
          <BackButton filter={filter} />
          <Breadcrumbs handleLevelSelected={handleLevelSelected} />
        </div>
        <div className={`d-flex justify-content-${hideCoverTitle ? 'end' : 'between'} align-items-center w-100`}>
          <h2
            id="pageTitle"
            className={`headerBar__title mr-0 mb-0${hideCoverTitle ? ' d-none' : ''}`}
          >
            {contentSummary ?  null :  <Bookmark /> }

            {contentSummary
              ? `Summary of ${currentDocument.title}`
              : currentDocument
              ? currentDocument.title
              : ''}
          </h2>
          <Search handleSearch={search} isDocument={true} />
        </div>
      </div>

      {/* mobile view */}
      <div id="mobile-view" className="flex-column w-100">
        <div className="d-flex justify-content-between align-items-center">
          <BackButton filter={filter} />
          <Search handleSearch={search} isDocument={true} />
        </div>
        <div className="d-flex justify-content-center align-items-center w-100">
          <Breadcrumbs handleLevelSelected={handleLevelSelected} />
        </div>
        <div className="d-flex justify-content-center align-items-center w-100">
          <h2
            id="pageTitleMobile"
            className={`headerBar__title mr-0 mb-0${hideCoverTitle ? ' d-none' : ''}`}
          >
            {contentSummary ?  null :  <Bookmark /> }
            
            {contentSummary
              ? `Summary of ${currentDocument.title}`
              : currentPage
              ? currentPage.title
              : ''}
          </h2>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  currentDocument: state.document.currentDocument,
  currentPage: state.document.currentPage,
  isPreview: state.client.isPreview,
  user: state.user.user,
  filter: state.user.filter
});

const connector = connect(mapStateToProps, null);

export default connector(HeaderBar);
